<template lang="pug">
  div
    b-row
      .col-xl-3.col-md-6
        .widget.widget-stats.bg-blue
          .stats-icon
            i.fa.fa-users
          .stats-info
            h4 {{ $t("ui.agent") }}
            p {{ agentCount }}
      .col-xl-3.col-md-6
        .widget.widget-stats.bg-info
          .stats-icon
            i.fa.fa-user
          .stats-info
            h4 {{ $t("ui.member") }}
            p {{ memberCount }}
    b-row
      .col-xl-3(v-if="$store.getters.accountType != 7")
        panel(:title='$t("ui.account")')
          .row.flex
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive
                table.table.table-sm.table-bordered
                  tbody
                    tr
                      th.width-xs(scope='row') {{ $t("ui.username")}}
                      td
                        span {{ $store.getters.accountID }}
                    tr
                      th(scope='row') {{ $t("ui.cash_balance")}}
                      td
                        currency(:currency="$store.getters.getAccountCurrency")
                        span(:class="$helpers.getNumberClass($store.getters.getAccountCashBalance)") {{ Math.floor($store.getters.getAccountCashBalance * 100) / 100 | currency }}
                    tr
                      th(scope='row') {{ $t("ui.account_balance")}}
                      td
                        currency(:currency="$store.getters.getAccountCurrency")
                        span(:class="$helpers.getNumberClass($store.getters.getAccountBalance)") {{ $store.getters.getAccountBalance | currency }}
                    tr(v-if="!$store.getters.cashMode")
                      th(scope='row') {{ $t("ui.credit_limit")}}
                      td
                        currency(:currency="$store.getters.getAccountCurrency")
                        span(:class="$helpers.getNumberClass($store.getters.getAccountCreditLimit)") {{ Math.floor($store.getters.getAccountCreditLimit * 100) / 100 | currency }}
                    tr(v-if="!$store.getters.cashMode")
                      th(scope='row') {{ $t("ui.remaining_credit")}}
                      td
                        currency(:currency="$store.getters.getAccountCurrency")
                        span(:class="$helpers.getNumberClass($store.getters.getAccountCreditLimit - $store.getters.getCreditUsedDownline)") {{ $store.getters.getAccountCreditLimit - $store.getters.getCreditUsedDownline | currency }}
      .col-xl-3(v-if="SBInfo")
        panel(:title='$t("ui.sportsbook")')
          .row.flex
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive
                table.table.table-sm.table-bordered
                  tbody
                    tr
                      th.width-xs(scope='row') {{ $t("ui.turnover")}}
                      td
                        span(:class="$helpers.getNumberClass(sportsbookInfo.turnover)") {{ sportsbookInfo.turnover | currency }}
                    tr
                      th(scope='row') {{ $t("ui.valid_turnover")}}
                      td
                        span(:class="$helpers.getNumberClass(sportsbookInfo.valid_turnover)") {{ sportsbookInfo.valid_turnover | currency }}
                    tr
                      th(scope='row') {{ $t("ui.winlose")}}
                      td
                        span(:class="$helpers.getNumberClass(sportsbookInfo.winlose)") {{ sportsbookInfo.winlose | currency }}
                    tr
                      th(scope='row') {{ $t("ui.commission")}}
                      td
                        span(:class="$helpers.getNumberClass(sportsbookInfo.comm)") {{ sportsbookInfo.comm | currency }}
      .col-xl-3(v-if="SLInfo")
        panel(:title='$t("ui.slots")')
          .row.flex
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive
                table.table.table-sm.table-bordered
                  tbody
                    tr
                      th.width-xs(scope='row') {{ $t("ui.turnover")}}
                      td
                        span(:class="$helpers.getNumberClass(slotsInfo.turnover)") {{ slotsInfo.turnover | currency }}
                    tr
                      th(scope='row') {{ $t("ui.valid_turnover")}}
                      td
                        span(:class="$helpers.getNumberClass(slotsInfo.valid_turnover)") {{ slotsInfo.valid_turnover | currency }}
                    tr
                      th(scope='row') {{ $t("ui.winlose")}}
                      td
                        span(:class="$helpers.getNumberClass(slotsInfo.winlose)") {{ slotsInfo.winlose | currency }}
                    tr
                      th(scope='row') {{ $t("ui.commission")}}
                      td
                        span(:class="$helpers.getNumberClass(slotsInfo.comm)") {{ slotsInfo.comm | currency }}
      .col-xl-3(v-if="LCInfo")
        panel(:title='$t("ui.livecasino")')
          .row.flex
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              .table-responsive
                table.table.table-sm.table-bordered
                  tbody
                    tr
                      th.width-xs(scope='row') {{ $t("ui.turnover")}}
                      td
                        span(:class="$helpers.getNumberClass(LCInfo.turnover)") {{ LCInfo.turnover | currency }}
                    tr
                      th(scope='row') {{ $t("ui.valid_turnover")}}
                      td
                        span(:class="$helpers.getNumberClass(LCInfo.valid_turnover)") {{ LCInfo.valid_turnover | currency }}
                    tr
                      th(scope='row') {{ $t("ui.winlose")}}
                      td
                        span(:class="$helpers.getNumberClass(LCInfo.winlose)") {{ LCInfo.winlose | currency }}
                    tr
                      th(scope='row') {{ $t("ui.commission")}}
                      td
                        span(:class="$helpers.getNumberClass(LCInfo.comm)") {{ LCInfo.comm | currency }}
</template>

<script>
import currency from "@/components/settings/currency.vue"

export default {
  components: {
    currency
  },
  data() {
    return {
      userInfo: null,
      totalActive: 0,
      totalClose: 0,
      totalFreeze: 0,
      totalSuspend: 0,
      todayWinlose: 0,
      yesterdayWinlose: 0,
      totalOutstanding: 0,
      onlinePlayer: 0,
      topWinner: [],
      topTurnover: [],
      topLoser: [],
      creditUsedSummary: [],
      agentList: {},
      memberList: [],
      pulling: null,

      agentCount: 0,
      memberCount: 0,
      sportsbookInfo: null,
      slotsInfo: null,
      liveCasinoInfo: null
    }
  },
  computed: {
    LCInfo() {
      return this.liveCasinoInfo;
    },
    SBInfo() {
      return this.sportsbookInfo;
    },
    SLInfo() {
      return this.slotsInfo;
    },
  },
  created: function() {
    this.pulling = setInterval(() => this.startOverview(), 1 * 30000);
  },
  beforeDestroy() {
    clearInterval(this.pulling);
  },
  mounted: function(){
    this.startOverview()
    var swal_alert = localStorage.getItem("alert");
    if(swal_alert != 1){
      let status = this.$store.getters.accountStatus
      if(status == 'SUSPEND') {
        this.$swal({
          title: this.$t("ui.suspend"),
          text: this.$t("message.suspend_alert"),
          html: "<div>" + this.$t("message.suspend_alert1") + "</div>" +
                "<div>" + this.$t("message.suspend_alert2") + "</div>",
          type: "warning",
          allowOutsideClick: false
        })
      }
    }
    localStorage.setItem("alert", "1");
  },
  methods: {
    startOverview: function() {
      this.$helpers.getCreditLimit(this.$store.getters.accountID, this.$store.getters.accountType)
      this.$helpers.getPositionTaking()
      this.$helpers.getCommission()
      this.$helpers.getBetLimit()
      this.$helpers.getSchedule()
      this.$helpers.getWallet()
      this.$helpers.getPlatform()
      this.getDashboardInfo()
    },
    getDashboardInfo: function(){
      this.$store
        .dispatch("user/getDashboardInfo")
        .then(response => {
          if (response.success == true) {
            if(response.data.agents) {
              if (response.data.agents.length > 0) {
                this.agentCount = response.data.agents[0].agent_count;
              }
            }

            if(response.data.members) {
              if (response.data.members.length > 0) {
                this.memberCount = response.data.members[0].member_count;
              }
            }

            if(response.data.products) {
              if (response.data.products.filter(x => x.category == "SPORTSBOOK").length > 0)
                this.sportsbookInfo = response.data.products.filter(x => x.category == "SPORTSBOOK")[0];

              if (response.data.products.filter(x => x.category == "SLOTS").length > 0)
                this.slotsInfo = response.data.products.filter(x => x.category == "SLOTS")[0];

              if (response.data.products.filter(x => x.category == "LIVECASINO").length > 0)
                this.liveCasinoInfo = response.data.products.filter(x => x.category == "LIVECASINO")[0];
            }

          }
        })
        .catch(response => {
        });
    }
  }
}
</script>
